import {HSL, HSLA, minuteInMS} from "web-vcore";

// use "Color Highlight" vscode extension to preview the colors (with "dot-after" marker-type)
const eegActivityLine = `hsl(200,100%,50%)`;
export const sessionChartColors = {
	// lines
	// ==========

	siren: `hsl(120,70%,30%)`,
	breath_force: `hsl(200,100%,50%)`,
	breath_desync: `hsl(30,100%,50%)`,
	breath_desync_long: `hsl(30,100%,40%)`,
	breath_desync_short: `hsl(30,100%,60%)`,
	breath_interval_long: `hsl(120,100%,40%)`,
	breath_interval_short: `hsl(120,100%,70%)`,
	breath_intervalPercentileX: `hsl(320,100%,50%)`,
	breath_intervalVariability: `hsl(300,100%,50%)`,
	breath_edgeShift: `hsl(270,100%,50%)`,
	/*breath_amplitude: `hsl(260,100%,50%)`,
	breath_amplitudeStdDev: `hsl(250,100%,50%)`,*/

	/*eeg_left: `hsl(0,0%,100%)`,
	eeg_right: `hsl(0,0%,50%)`,*/
	eeg_left: `hsl(0,100%,50%)`,
	eeg_right: `hsl(60,100%,50%)`,
	eeg_left_ear: `hsl(250,100%,50%)`,
	eeg_right_ear: `hsl(280,100%,50%)`,
	eegActivity: eegActivityLine,
	//sleepStage: `hsl(230,100%,50%)`,
	sleepStage: `hsl(0,100%,50%)`,

	gyro_x: `hsl(0,100%,50%)`,
	gyro_y: `hsl(30,100%,50%)`,
	gyro_z: `hsl(60,100%,50%)`,
	gyro_combinedDeviation: `hsl(300,100%,50%)`,
	gyro_triggerSamplePercent: `hsl(120,100%,50%)`,

	// annotations
	// ==========


	baseline: `hsla(0,0%,100%,.65)`,
	currentTimeLine: `hsl(60,100%,50%)`,
	viewRangeRegion: "hsla(0,0%,100%,.65)",

	waking_nonLucid: `hsl(0,100%,50%)`,
	waking_semiLucid: `hsl(32,100%,50%)`, // rgba(255,128,0,1)
	waking_lucid: `hsl(60,100%,50%)`, // rgba(255,255,0,1)
	dreamPeriod: `hsla(220,100%,70%,.25)`,
	//snoozePeriod: `hsla(60,100%,70%,.25)`,
	snoozePeriod: `hsla(60,0%,70%,.25)`,
	solvingPeriod: `hsla(60,0%,70%,.25)`,
	deildAttemptStart: `rgb(0, 255, 242)`,
	visPromptPeriod: `hsla(300,100%,50%,.25)`,
	alertPeriod: `hsla(20,100%,70%,.25)`,
	breath_intervalThreshold_base: `hsla(30,100%,50%,.65)`,
	breath_intervalThresholdLowRange_base: `hsla(30,100%,75%,.65)`,
	breath_peak: `hsla(30,100%,50%,.5)`,
	breath_peak_moreOpaque: `hsla(30,100%,50%,.95)`,
	breath_longInhales: `hsla(240,100%,70%,1)`,

	gyroMotionColor: `hsla(240,100%,70%,1)`,
	testSegmentRegion: `hsla(60,50%,50%,.15)`,
	camRecordingRegion: `hsla(60,100%,50%,.25)`,
	eyeMoveDeclaration_required: `hsla(240,100%,70%,1)`,
	eyeMoveDeclaration_optional: `hsla(39,100%,50%,1)`,
	eyeMoveDetection_passed: `hsla(120,100%,50%,.2)`,
	eyeMoveDetection_failed: `hsla(0,100%,50%,.2)`,

	// special (ie. bases)
	promptThreshold_baseColor: eegActivityLine, // for now, have color match "EEG activity" line
};
export function GetPromptThresholdColor(index: number, promptCount: number) {
	return sessionChartColors.promptThreshold_baseColor;
	// todo: make this adjust base-color based on index
}

// other random chart-related constants
// ==========

//export const BREATH_PEAKS_CALC_MIN_PROMINENCE_RATIO_DEFAULT = 0.1;
export const BREATH_PEAKS_CALC_MIN_DIST_BETWEEN_PEAKS_DEFAULT = 2000;
export const BREATH_PEAKS_CALC_WINDOW_SIZE_DEFAULT = 10000; // just large enough to reliably reach the previous breath's peak

export const BREATH_INTERVAL_CALC_WINDOW_SIZE_LONG = 5 * minuteInMS;
export const BREATH_INTERVAL_CALC_WINDOW_SIZE_SHORT = 30000;
//export const BREATH_INTERVAL_CALC_REJECT_BREATHS_LONGER_THAN = 10000;

export const BREATH_INTERVAL_PERCENTILE_X_CALC_WINDOW_SIZE = 5 * minuteInMS;
export const BREATH_INTERVAL_PERCENTILE_X_VISUAL_MULTIPLIER = 1;
export const BREATH_INTERVAL_PERCENTILE_X_THRESHOLD_X = .1;
export const BREATH_INTERVAL_PERCENTILE_X_THRESHOLD_Y = .3;

export const BREATH_VARIABILITY_ON_INTERVAL_CALC_WINDOW_SIZE = 5 * minuteInMS;
export const BREATH_VARIABILITY_ON_INTERVAL_VISUAL_MULTIPLIER = 3;

export const BREATH_EDGE_SHIFT_CALC_WINDOW_SIZE = 5 * minuteInMS;
export const BREATH_EDGE_SHIFT_VISUAL_MULTIPLIER = 30;

/*export const BREATH_AMPLITUDE_CALC_WINDOW_SIZE = 5 * minuteInMS;
export const BREATH_AMPLITUDE_VISUAL_MULTIPLIER = 1;

export const BREATH_AMPLITUDE_STD_DEV_CALC_WINDOW_SIZE = 5 * minuteInMS;
export const BREATH_AMPLITUDE_STD_DEV_VISUAL_MULTIPLIER = 1;*/

export const BREATH_VALUE_STD_DEV_CALC_WINDOW_SIZE = 5 * minuteInMS;
export const BREATH_LINE_TRAVEL_DISTANCE_CALC_WINDOW_SIZE = 5 * minuteInMS;